import { PaymentMethod, PromoCode } from './payment.actions';
import { EventDetailOutputDto, FilterTransactionByPaidEventsResponse, TransactionHistoryItemDto } from '@smatchy/sdk';

export interface PaymentStateModel {
  selectedPaymentMethod: PaymentMethod | null;
  appliedPromoCode: PromoCode | null;
  paymentAmount: number;
  isProcessing: boolean;
  paymentError: string | null;
  paymentSuccess: boolean;
  transactionId: string | null;
  activityData: EventDetailOutputDto | null;
  paymentMethods: PaymentMethod[];
  transactionHistory: TransactionHistoryItemDto[];
  loadingTransactionHistory: boolean;
  /*
   * `| null` on the four, because that is what the defaults below and the reset
   * write: no filter is null here, not undefined. Said rather than converted,
   * since this state is persisted and null survives a round trip through
   * localStorage where undefined does not.
   */
  filterTransactions?: FilterTransactionByPaidEventsResponse | null;
  dateFilter: string | null;
  fromDate?: string | null;
  toDate?: string | null;
  priceFrom?: number;
  priceTo?: number;
  pricingChanged?: boolean;
  statuses: string[];
  /**
   * True once payment_completed has been emitted for the current attempt.
   * PaymentSuccess is dispatched from five places and PaymentError from
   * nineteen, so without this a single attempt emits the event several times.
   * Reset by ProcessPayment and by ResetPaymentState.
   */
  outcomeLogged: boolean;
}

export const defaultPaymentStateModel: PaymentStateModel = {
  selectedPaymentMethod: null,
  appliedPromoCode: null,
  paymentAmount: 0,
  outcomeLogged: false,
  isProcessing: false,
  paymentError: null,
  paymentSuccess: false,
  transactionId: null,
  activityData: null,
  paymentMethods: [],
  transactionHistory: [],
  loadingTransactionHistory: false,
  filterTransactions: null,
  dateFilter: '',
  fromDate: null,
  toDate: null,
  priceFrom: 0,
  priceTo: 10000,
  pricingChanged: false,
  statuses: [],
};
